import { defaultLocale, locales } from '@/i18n/constants';
import {defineRouting} from 'next-intl/routing';
 
export const routing = defineRouting({
  // A list of all locales that are supported
  locales: locales,
 
  // Used when no locale matches
  defaultLocale: defaultLocale,

  // We handle locale detection in our middleware
  localeDetection: true,

  // The cookie is set when the user switches to a locale that does not match the Accept-Language header
  localeCookie: {
    name: 'SORA_LOCALE',
    maxAge: 60 * 60 * 24 * 182, // 6 months
  },
});